import { getHashOrQueryParam } from '../../window/WindowUtils';

const getAuth0State = (): string => {
  return getHashOrQueryParam('state');
};

export { getAuth0State };
